<div class="box box--min-height right-box u-ml-- u-p0">
  <form [formGroup]="form" class="search-form u-p" wfmScrollbar>
    <div class="form__fieldset">
      <div>
        <label for="pid" class="form__label form__label--bottom">
          <span class="form__label-inner-wrap">
            <span>{{'label.pid'| translate}}</span>
          </span>
        </label>
        <div
          class="flex flex--nowrap flex--row"
          id="uniqueComponentId"
          aria-invalid="false"
          aria-describedby="pid-error"
        >
          <input
            formControlName="pid"
            type="text"
            class="textbox u-pr"
            placeholder="{{'label.pid' | translate}}"
            [attr.aria-invalid]="
              formControls.pid.errors?.maxlength || formControls.pid.errors?.pidSuffixPrefixValidation ? true : false
            "
          />
          <button
            type="button"
            *ngIf="formControls.pid.value"
            id="close-icon"
            aria-label="Clear"
            class="button button--icon button--tertiary button--no-border button--close"
            (click)="resetField('pid')"
          >
            <svg-icon
              name="ico-close-16"
              [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
            ></svg-icon>
          </button>
        </div>
      </div>
      <div *ngIf="formControls.pid.errors?.maxlength || formControls.pid.errors?.pidSuffixPrefixValidation">
        <div role="alert" class="form__error-text" id="pidError">
          <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }">
          </svg-icon>
          <span id="error-message" class="error-message">
            {{ 'advancedSearch.error.invalidInputCharacters' | translate }}</span
          >
        </div>
      </div>
    </div>
    <div class="form__fieldset">
      <div>
        <label for="pname" class="form__label form__label--bottom u-mt">
          <span class="form__label-inner-wrap">
            <span>{{'dicomqr.patientNameLabel' | translate}} </span>
          </span>
        </label>
        <div class="flex flex--nowrap flex--row" id="pname" aria-invalid="true" aria-describedby="pid-error">
          <input
            formControlName="patientName"
            type="text"
            dir="auto"
            class="textbox u-pr"
            placeholder="{{'patientHistory.popover.lastNameLabel' | translate}}, {{'patientHistory.popover.firstNameLabel' | translate}}"
            [attr.aria-invalid]="
              formControls.patientName.errors?.maxlength || formControls.patientName.errors?.patientNameValidation
                ? true
                : false
            "
          />
          <button
            type="button"
            *ngIf="formControls.patientName.value"
            id="close-icon"
            aria-label="Clear"
            class="button button--icon button--tertiary button--no-border button--close"
            (click)="resetField('patientName')"
          >
            <svg-icon
              name="ico-close-16"
              [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
            ></svg-icon>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="formControls.patientName.errors?.maxlength || formControls.patientName.errors?.patientNameValidation">
      <div role="alert" class="form__error-text" id="patientNameError">
        <svg-icon name="ico-form-error-16" [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: '#DF4661' }">
        </svg-icon>
        <span id="error-message" class="error-message">
          {{ 'advancedSearch.error.invalidInputCharacters' | translate }}</span
        >
      </div>
    </div>
    <div class="form__fieldset">
      <div class="form__date-picker">
        <label for="dob" class="form__label form__label--bottom u-mt">
              <span class="form__label-inner-wrap">
                <span> {{'savedExams.dobLabel'| translate}}</span>
              </span>
        </label>
        <div class="flex flex--nowrap flex--row" id="dob">
          <wfm-date-picker
            [disabled]="formControls.patientName.invalid || formControls.pid.invalid"
            [error]="false"
            [format]="dateTimePref.inputFormat"
            [placeholder]="dateTimePref.placeholderFormat"
            [autoWidth]="false"
            [hideOtherMonths]="true"
            [rangeMode]="false"
            (valueChange)="setDob($event)"
            (errorChange)="setDobError($event)"
            [value]="patientDateOfBirth"
          >
          </wfm-date-picker>
        </div>
      </div>
    </div>
    <div class="form__fieldset">
      <div>
        <label for="gender" class="form__label form__label--bottom u-mt">
          <span class="form__label-inner-wrap">
            <span> {{'workloadManager.listContainer.label.gender'| translate}} </span>
          </span>
        </label>
        <div class="flex flex--nowrap flex--row" id="gender">
          <wfm-select-dropdown
            [disabled]="formControls.pid.invalid || formControls.patientName.invalid"
            [items]="genderOptions"
            [(value)]="patientGender"
            (valueChange)="setGender($event)"
            placeholder="{{'label.select.gender' | translate}}"
          ></wfm-select-dropdown>
        </div>
      </div>
    </div>
    <div class="flex flex--nowrap flex--row flex--right u-pt">
      <button
        type="submit"
        aria-pressed="false"
        class="button"
        [disabled]="form.invalid"
        (keydown.enter)="onSearch()"
        (click)="onSearch()"
      >
        <span>{{'label.search'| translate}}</span>
      </button>
    </div>
  </form>
</div>
